export const fallbackLng = "en";
export const languages = [fallbackLng, "id", "jp"];
export const defaultNS = "translation";
export const cookieName = "i18next";

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}

export function getContentByLng(
  lng: ListLangType,
  contentEn: string,
  contentId: string,
  contentJp: string
) {
  return lng === "en"
    ? contentEn
    : lng === "id"
    ? contentId
    : lng === "jp"
    ? contentJp
    : null;
}

export function getPathname(lng: ListLangType, pathname?: string) {
  return pathname ? `/${lng}/${pathname}` : `/${lng}`;
}

export type ListLangType = "en" | "id" | "jp";

export interface ParamsI18n {
  t?: any;
  lng?: ListLangType;
}
